import React, { useState } from "react";

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, makeStyles, MenuItem, Select, Tooltip } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";

import { SupportedTranslations } from "../../../../../src/entities/BibleTranslation";
import { BibleSearchSetting, BibleSearchSettingsOptions } from "../../../../../src/entities/BibleSearchSettings";

const useStyles = makeStyles((theme) => ({
	mobileSpacing: {
		[theme.breakpoints.down("xs")]: {
			marginTop: "2em",
		},
	},
}));

interface Props {
	open: boolean;
	onClose: () => void;
	onSaveSettings: (selectedTranslationId: string, selectedCopySetting: BibleSearchSetting, selectedViewSetting: BibleSearchSetting) => void;
	selectedTranslationId: string;
	selectedCopySetting: BibleSearchSetting;
	selectedViewSetting: BibleSearchSetting;
}
export interface State {
	selectedTranslationId: string;
	selectedCopySetting: BibleSearchSetting;
	selectedViewSetting: BibleSearchSetting;
}

export function BibleSettingsDialog(props:Props) {
	const [selectedTranslationId, setSelectedTranslationId] = useState(props.selectedTranslationId)
	const [selectedCopySetting, setSelectedCopySetting] = useState(props.selectedCopySetting)
	const [selectedViewSetting, setSelectedViewSetting] = useState(props.selectedViewSetting)
	const classes = useStyles();

	const saveSettings = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		props.onSaveSettings(selectedTranslationId, selectedCopySetting, selectedViewSetting);
	};

	return (
		<Dialog open={props.open} onClose={props.onClose}>
			<DialogTitle id="form-dialog-title">Settings</DialogTitle>
			<form onSubmit={(e) => saveSettings(e)}>
				<DialogContent style={{ paddingTop: 0 }}>
					<FormControl fullWidth margin="normal">
						<Tooltip title="Choose Your Preferred Bible Translation" placement="top">
							<InputLabel htmlFor="Translation" style={{ fontSize: 21 }}>
								Bible Translation <InfoIcon style={{ fontSize: 17 }} />
							</InputLabel>
						</Tooltip>
						<Select
							inputProps={{
								name: "Translation",
								id: "Translation",
							}}
							value={selectedTranslationId}
							onChange={(event) =>setSelectedTranslationId(event.target.value as string)}
							className={classes.mobileSpacing}
						>
							{SupportedTranslations.map((translation) => {
								return (
									<MenuItem
										key={translation.id}
										value={translation.id}
										selected={translation.id === props.selectedTranslationId}
									>
										{translation.name}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
					<FormControl fullWidth margin="normal">
						<Tooltip title="Choose how Scripture is copied to your clipboard" placement="top">
							<InputLabel htmlFor="copy-settings" style={{ fontSize: 21 }} shrink>
								Copy and Paste Options <InfoIcon style={{ fontSize: 17 }} />
							</InputLabel>
						</Tooltip>
						<Select
							inputProps={{
								name: "CopySettings",
								id: "CopySettings",
							}}
							value={selectedCopySetting}
							onChange={(event) => setSelectedCopySetting(event.target.value as BibleSearchSetting)}
							className={classes.mobileSpacing}
						>
							{BibleSearchSettingsOptions.map((option) => {
								return (
									<MenuItem key={option.id} value={option.id} selected={option.id === props.selectedCopySetting}>
										{option.name}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
					<FormControl fullWidth margin="normal">
						<Tooltip title="Choose how Scripture is displayed in the search results" placement="top">
							<InputLabel htmlFor="view-settings" style={{ fontSize: 21 }}>
								View Options <InfoIcon style={{ fontSize: 17 }} />
							</InputLabel>
						</Tooltip>
						<Select
							inputProps={{
								name: "ViewSettings",
								id: "ViewSettings",
							}}
							value={selectedViewSetting}
							onChange={(event) =>setSelectedViewSetting(event.target.value as BibleSearchSetting)}
							className={classes.mobileSpacing}
						>
							{BibleSearchSettingsOptions.map((option) => {
								return (
									<MenuItem key={option.id} value={option.id} selected={option.id === props.selectedViewSetting}>
										{option.name}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
					{selectedCopySetting !== selectedViewSetting && (
						<div style={{ color: "red", fontSize: "0.8em" }}>
							Please note: Your "Copy and Paste Options" and "View Options" don't match. Visible verses may not match verses copied
							to your clipboard.
						</div>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={props.onClose} color="primary">
						Cancel
					</Button>
					<Button type="submit" color="primary">
						Apply Settings
					</Button>
				</DialogActions>
			</form>
		</Dialog>
	);
}